import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '@/lib/backendUrl';
import { resolvePhotoUrl } from '@/hooks/useFounderPage';

/**
 * Overlapping row of real faces (audit D3.1): the founder's public portrait first, then members who
 * explicitly opted in from their profile. Photos only — no names, no links. Empty → renders nothing.
 */
export function MemberAvatars({ size = 'md' }) {
  const [tiles, setTiles] = useState([]);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/member-avatars`).then((r) => setTiles(r.data.avatars || [])).catch((e) => console.warn('member avatars unavailable', e));
  }, []);
  const shown = tiles.filter((t) => t.url);
  if (!shown.length) return null;
  const dim = size === 'sm' ? 'w-6 h-6' : 'w-8 h-8';
  return (
    <ul className="flex -space-x-2 shrink-0" aria-label="Some of the people who have joined Sahiri" data-testid="member-avatars">
      {shown.map((t) => (
        <li key={t.id} className="relative group" data-testid={t.founder ? 'member-avatar-founder' : 'member-avatar'}>
          <img
            src={resolvePhotoUrl(t.url)}
            alt={t.alt}
            title={t.label}
            width={32}
            height={32}
            loading="lazy"
            className={`${dim} rounded-full object-cover ring-2 ring-[var(--bg-surface)] bg-[var(--bg-subtle)]`}
            onError={(e) => { e.currentTarget.closest('li').style.display = 'none'; }}
          />
          <span role="tooltip" className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-8 whitespace-nowrap rounded-md px-2 py-1 text-[11px] text-white opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity" style={{ backgroundColor: 'var(--text-primary)' }}>{t.label}</span>
        </li>
      ))}
    </ul>
  );
}
